// NOTE: Only works when a DOM is available, and file sizes are constrained by
// browsers.
export const exportBlobToFile = ({
  blob,
  filename,
}: {
  blob: Blob;
  filename: string;
}) => {
  const anchorElement = document.createElement('a');
  anchorElement.href = URL.createObjectURL(blob);
  anchorElement.download = filename;
  anchorElement.click();
  URL.revokeObjectURL(anchorElement.href);
};

export const exportToFile = ({
  contents,
  mimeType,
  filename,
}: {
  contents: string;
  mimeType: string;
  filename: string;
}) => {
  const blob = new Blob([contents], {
    type: mimeType,
  });
  exportBlobToFile({ blob, filename });
};
